














import { Component, Prop } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import Header from '@/components/playLayout/header.vue'

@Component({
  components: {
    Header,
  }
})
export default class PlayPane extends ViewBase {
  @Prop({ type: Number, default: 1 }) nav!: number
}
